import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material';
import useMediaQueries from '../../../hooks/useMediaQueries';
;
const Container = styled('div', {
    shouldForwardProp: prop => prop !== 'isDesktop',
}) `
  position: sticky;
  width: 100%;
  z-index: ${({ theme }) => theme.zIndex.appBar};
  display: flex;
  flex-direction: ${({ isDesktop }) => (isDesktop ? 'row' : 'column')};
  justify-content: space-between;
  gap: ${({ isDesktop }) => (isDesktop ? '16px' : '10px')};
  bottom: 0;
  padding-top: 16px;
  padding-bottom: ${({ isDesktop }) => (isDesktop ? '24px' : '16px')};
  padding-left: var(--standard-spacing-x, 24px);
  padding-right: var(--standard-spacing-x, 24px);
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  background-color: ${({ theme }) => theme.palette.background.default};
`;
const ActionContainer = styled('div') `
  display: flex;
  gap: 12px;
`;
const BottomActionContainer = ({ leftChildren = undefined, rightChildren = undefined, className = undefined, }) => {
    const { fitForDesktop } = useMediaQueries();
    return (_jsxs(Container, { className: className, isDesktop: fitForDesktop, children: [_jsx(ActionContainer, { children: leftChildren }), _jsx(ActionContainer, { children: rightChildren })] }));
};
export default BottomActionContainer;
//# sourceMappingURL=index.js.map